<template>
  <button class="floating-button" @click="openNewPage">
    <svg viewBox="0 0 60 60" class="icon">
      <path d="M6.90917448,41.3294845 C6.83769725,41.212437 6.76324712,41.0951946 6.68573397,40.9777778 L6.76289975,41.0481461 C4.99532213,37.5958143 4,33.6955382 4,29.5666667 C4,15.4465866 15.6405965,4 30,4 C44.3594035,4 56,15.4465866 56,29.5666667 C56,43.6867468 44.3594035,55.1333333 30,55.1333333 C26.3565321,55.1333333 22.8881035,54.3963917 19.7404572,53.0658224 C-3.68800108,60.6255746 12.4215438,52.3468261 7.38027718,42.1818397 C7.21794615,41.9009974 7.06086812,41.616836 6.90917448,41.3294845 Z" class="path1" fill="white"></path>
      <path d="M30,18 C23.9365932,18 19,22.6462054 19,28.3529412 L19,31.4889704 L19,32.1176471 C19,33.1576471 19.895,34 21,34 L23,34 L23,29.2941176 C23,28.2730456 22.1357546,27.4471736 21.0585938,27.4172791 C21.5517466,23.1712651 25.354019,19.8823529 30,19.8823529 C34.645981,19.8823529 38.448253,23.1712651 38.941406,27.4172791 C37.864245,27.4471736 37,28.2730456 37,29.2941176 L37,34 L39,34 C40.105,34 41,33.1576471 41,32.1176471 L41,29.2941176 L41,28.3529412 C41,22.6462054 36.063407,18 30,18 Z M37,38 L37,38.8333333 C37,39.7638883 36.116666,40.5 35,40.5 L31.728516,40.5 C31.3718826,39.9852418 30.713268,39.6677177 30,39.6666667 C28.8954305,39.6666667 28,40.4128588 28,41.3333333 C28,42.2538079 28.8954305,43 30,43 C30.713966,42.9995293 31.3734861,42.6819275 31.730469,42.1666667 L35,42.1666667 C37.197334,42.1666667 39,40.664445 39,38.8333333 L39,38 L37,38 Z" class="path2" fill="white"></path>
    </svg>
    {{ $t('newsletterCard.helpVideoSupport') }}
  </button>
</template>

<script>
export default {
  methods: {
    openNewPage () {
      window.open('https://taptasty-support.freshdesk.com/support/tickets/new', '_blank')
    }
  }
}
</script>

<style scoped>
.floating-button {
  display: none !important;
  position: fixed;
  bottom: 120px;
  right: 20px;
  background-color: #674BD2;
  color: white;
  border: none;
  border-radius: 8px; /* Facem colțurile ușor rotunjite */
  padding: 10px 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  z-index: 9999;
  font-size: 16px;
}

.icon {
  width: 28px;
  height: 28px;
  margin-right: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/UIComponents/CreateTicketBubble.vue